// extracted by mini-css-extract-plugin
export default {"maxWidth":"dashboardPage_maxWidth__qYepA","activeAnalyticsHeader":"dashboardPage_activeAnalyticsHeader__kRT3X"};